import { Component, inject, OnDestroy, signal, ViewContainerRef } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { ThemeService } from './services/theme.service';
import { MinimizedBar } from './components/shared/minimized-bar/minimized-bar';
import { LoaderComponent } from './components/shared/loader/loader';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    MinimizedBar,
    LoaderComponent,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnDestroy {
  public vcRef = inject(ViewContainerRef);
  protected readonly title = signal('datalink-dashboard-fe');
  private readonly themeService = inject(ThemeService);
  private readonly router = inject(Router);

  protected readonly showLoader = signal(false);
  private showTimeout: ReturnType<typeof setTimeout> | null = null;
  private readonly routerSub: Subscription;

  constructor() {
    this.themeService.setTheme(this.themeService.mode());

    this.routerSub = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.showTimeout = setTimeout(() => this.showLoader.set(true), 500);
      }
      if (event instanceof NavigationEnd
        || event instanceof NavigationCancel
        || event instanceof NavigationError) {
        if (this.showTimeout) {
          clearTimeout(this.showTimeout);
          this.showTimeout = null;
        }
        this.showLoader.set(false);
      }
    });
  }

  ngOnDestroy(): void {
    this.routerSub.unsubscribe();
    if (this.showTimeout) clearTimeout(this.showTimeout);
  }
}
